export function isHonoApiModeFromEnv(env) {
  const flag = (env.VITE_USE_HONO_API || '').trim().toLowerCase()
  return flag === 'true' || flag === '1' || flag === 'yes'
}

export function resolveApiBaseUrlFromEnv(env) {
  if (isHonoApiModeFromEnv(env) && env.VITE_API_BASE_URL?.trim()) {
    return env.VITE_API_BASE_URL.replace(/\/$/, '')
  }
  if (env.VITE_SUPABASE_URL?.trim()) {
    return `${env.VITE_SUPABASE_URL.replace(/\/$/, '')}/functions/v1`
  }
  if (env.VITE_API_BASE_URL?.trim()) {
    return env.VITE_API_BASE_URL.replace(/\/$/, '')
  }
  throw new Error('Missing VITE_API_BASE_URL or VITE_SUPABASE_URL')
}
